// ─────────────────────────────────────────────
// KLOTHIQ — Customer Zod Schema
// ─────────────────────────────────────────────

import { z } from 'zod';
import { optionalCustomerPhoneSchema, emailSchema, pincodeSchema } from './common.schema';

export const customerFormSchema = z.object({
  name: z.string().min(1, 'Customer name is required').max(200, 'Name too long'),
  phone: optionalCustomerPhoneSchema,
  email: emailSchema,
  address: z.string().max(500).nullable().optional(),
  city: z.string().max(100).nullable().optional(),
  pincode: pincodeSchema,
  notes: z.string().max(1000).nullable().optional(),
  is_active: z.boolean().default(true),
});

export type CustomerFormValues = z.infer<typeof customerFormSchema>;
